import * as React from 'react';



export default class UserDetail extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd" transform="translate(1 3)">
            <rect width="14" height="10" stroke="#000" rx="2"/>
            <g transform="translate(1.643 2)">
                <circle cx="2.357" cy="1.333" r="1.333" stroke="#333"/>
                <path stroke="#333" d="M4.714 5.024c0-1.302-1.055-2.357-2.357-2.357C1.055 2.667 0 3.722 0 5.024c0 1.301 4.714 1.301 4.714 0z"/>
                <path className="detaiFill" stroke="#24B3FF" d="M5.871 1.333L10.731 1.333M5.871 2.667L9.398 2.667"/>
            </g>
        </g>
      </svg>
    )
  }
}